import classNames from "classnames";
import React, { ReactNode } from "react";

import "./index.less";

interface ButtonGroupProps {
  size?: ButtonSizeType;
  children: ReactNode;
  className?: string;
}

type ButtonSizeType = "sm" | "md";

export default function ACButtonGroup({
  size = "sm",
  children,
  className,
}: ButtonGroupProps) {
  return (
    <div
      className={classNames("ac-btn-group", `ac-btn-group-${size}`, className)}
    >
      {children}
    </div>
  );
}

interface ButtonGroupItemProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
}

export function ACButtonGroupItem({
  children,
  className,
  disabled,
  ...restProps
}: ButtonGroupItemProps) {
  return (
    <button
      disabled={disabled}
      className={classNames(
        "ac-btn-group-item",
        {
          "ac-btn-disabled": disabled,
        },
        className,
      )}
      {...restProps}
    >
      {children}
    </button>
  );
}
